import React, { useEffect, useMemo } from "react";
import "./SalesReturnReport.css";

import SalesReturnReportHeader from "../SalesReturnReport/SalesReturnReportHeader/SalesReturnReportHeader";
import SalesReturnReportFooter from "./SalesReturnReportFooter/SalesReturnReportFooter";
import { useDispatch, useSelector } from "react-redux";
import {
  getRAReportItem,
  getRAReportPrint,
  getRAReportColumnValue,
  getRAReportColumn,
} from "../../redux/actions/rAReport.action";
import { Button } from "antd";
import { useLocation } from "react-router-dom";
import moment from "moment";
import { currencySymbol } from "../../utils/constants";
import Loader from "react-loader-spinner";

const SalesReturnReport = ({ token }) => {
  const dispatch = useDispatch();
  const {
    RAPrint,
    RAColumn,
    RAColumnValue,
  } = useSelector((state) => state);

  function useQuery() {
    const { search } = useLocation();
    return React.useMemo(() => new URLSearchParams(search), [search]);
  }

  let query = useQuery();
  let return_header_id = query.get("return_header_id");

  const footerData = RAPrint && RAPrint?.payload?.data[0];

  let groupValues =
    RAColumnValue &&
    RAColumnValue?.payload?.data.reduce(function (r, a) {
      r[a.gender_category_id] = r[a.gender_category_id] || [];
      r[a.gender_category_id].push(a);
      return r;
    }, Object.create(null));

  const groupedColumnValue = groupValues && Object.values(groupValues);

  const values = {
    return_header_id: return_header_id,
  };

  useEffect(() => {
    dispatch(getRAReportItem(token, values));
    dispatch(getRAReportPrint(token, values));
    dispatch(getRAReportColumnValue(token, values));
    dispatch(getRAReportColumn(token, values));
  }, [dispatch, token]);

  const myData = useMemo(() => {
    return RAColumn?.payload?.data.map((it, i) => {
      return {
        column: it,
        detail: groupedColumnValue && groupedColumnValue[i],
      };
    });
  }, [groupedColumnValue, RAColumn]);

  const handlePrint = () => {
    const css = '@page { size: A4 landscape; margin: 2mm 10mm !important;}';
    const style = document.createElement('style');
    style.innerHTML = css;
    document.head.appendChild(style);
    window.print();
    document.head.removeChild(style); // Clean up after print
  };

  if (RAPrint?.loading) {
    return <>
      <div className='loaderDiv' >
        <Loader
          type="Grid"
          color="#212121"
          height={40}
          width={40}
        />
      </div>
    </>
  }

  return (
    <div className="__sale_return_auth_report">
      <table width="100%">
        <thead>
          <tr>
            <td>
              <SalesReturnReportHeader />
            </td>
          </tr>
        </thead>
        <tbody>
          <tr className="no-print">
            <td>
              <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '16px', marginRight: "114px" }}>
                <Button type="primary" onClick={handlePrint}>
                  Print
                </Button>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <Body myData={myData} footerData={footerData} />
              <SalesReturnReportFooter />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

const Body = ({ myData, footerData }) => {
  return (
    <>
      <div className="__content">
        <div className="__list_items">
          {myData?.map((size, index) => {
            return (
              <table key={index} width="100%">
                <tbody>
                  <tr>
                    <th
                      style={{
                        width: "36px",
                      }}
                    >
                      S.No
                    </th>
                    <th
                      style={{
                        width: "88px",
                      }}
                    >
                      SKU #
                    </th>
                    {/* <th
                      style={{
                        width: "80px",
                      }}
                    >
                      Brand
                    </th> */}
                    <th
                      style={{
                        width: "240px",
                      }}
                    >
                      Style/Desc
                      <span style={{ marginLeft: "5px" }}>
                        {size?.column?.gender_category_name}
                      </span>
                    </th>
                    <th
                      className="__size_col"
                    >
                      {size.column.hq23 && size.column.hq23}
                    </th>
                    <th className="__size_col">
                      {size.column.hq24 && size.column.hq24}
                    </th>
                    <th className="__size_col">
                      {size.column.hq25 && size.column.hq25}
                    </th>
                    <th className="__size_col">
                      {size.column.hq26 && size.column.hq26}
                    </th>
                    <th className="__size_col">
                      {size.column.hq27 && size.column.hq27}
                    </th>
                    <th className="__size_col">
                      {size.column.hq28 && size.column.hq28}
                    </th>
                    <th className="__size_col">
                      {size.column.hq29 && size.column.hq29}
                    </th>
                    <th className="__size_col">
                      {size.column.hq30 && size.column.hq30}
                    </th>
                    <th className="__size_col">
                      {size.column.hq31 && size.column.hq31}
                    </th>
                    <th className="__size_col">
                      {size.column.hq32 && size.column.hq32}
                    </th>
                    <th className="__size_col">
                      {size.column.hq33 && size.column.hq33}
                    </th>
                    <th className="__size_col">
                      {size.column.hq34 && size.column.hq34}
                    </th>
                    <th className="__size_col">
                      {size.column.hq35 && size.column.hq35}
                    </th>
                    <th className="__size_col">
                      {size.column.hq36 && size.column.hq36}
                    </th>
                    <th className="__size_col">
                      {size.column.hq37 && size.column.hq37}
                    </th>
                    <th className="__size_col">
                      {size.column.hq38 && size.column.hq38}
                    </th>
                    <th
                      style={{
                        width: "50px",
                      }}
                    >
                      Quantity
                    </th>
                    <th
                      style={{
                        width: "90px",
                      }}
                    >
                      Rate
                    </th>
                    <th
                      style={{
                        width: "90px",
                      }}
                    >
                      Amount
                    </th>
                  </tr>
                  {size.detail?.map((it, index) => {
                    return (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td
                          style={{
                            marginLeft: "0",
                          }}
                        >
                          {it.item_code}
                        </td>
                        {/* <td>
                          {it?.sku_brand_name}
                        </td> */}
                        <td>
                          {it.description}
                        </td>
                        <td className="__size_col">
                          {it.q23 && Number(it.q23).toFixed(0)}
                        </td>
                        <td className="__size_col">
                          {it.q24 && Number(it.q24).toFixed(0)}
                        </td>
                        <td className="__size_col">
                          {it.q25 && Number(it.q25).toFixed(0)}
                        </td>
                        <td className="__size_col">
                          {it.q26 && Number(it.q26).toFixed(0)}
                        </td>
                        <td className="__size_col">
                          {it.q27 && Number(it.q27).toFixed(0)}
                        </td>
                        <td className="__size_col">
                          {it.q28 && Number(it.q28).toFixed(0)}
                        </td>
                        <td className="__size_col">
                          {it.q29 && Number(it.q29).toFixed(0)}
                        </td>
                        <td className="__size_col">
                          {it.q30 && Number(it.q30).toFixed(0)}
                        </td>
                        <td className="__size_col">
                          {it.q31 && Number(it.q31).toFixed(0)}
                        </td>
                        <td className="__size_col">
                          {it.q32 && Number(it.q32).toFixed(0)}
                        </td>
                        <td className="__size_col">
                          {it.q33 && Number(it.q33).toFixed(0)}
                        </td>
                        <td className="__size_col">
                          {it.q34 && Number(it.q34).toFixed(0)}
                        </td>
                        <td className="__size_col">
                          {it.q35 && Number(it.q35).toFixed(0)}
                        </td>
                        <td className="__size_col">
                          {it.q36 && Number(it.q36).toFixed(0)}
                        </td>
                        <td className="__size_col">
                          {it.q37 && Number(it.q37).toFixed(0)}
                        </td>
                        <td className="__size_col">
                          {it.q38 && Number(it.q38).toFixed(0)}
                        </td>
                        <td>
                          {it.item_quantity && it.item_quantity}
                        </td>
                        <td>{currencySymbol} {it.rate && Number(it.rate).toFixed(2)}</td>
                        <td>{currencySymbol} {it.amount && Number(it.amount).toFixed(2)}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            );
          })}
        </div>
        <div className="__summary_box">
          <table width="100%">
            <tbody>
              <tr>
                <td valign="top">
                  <p>* Invoice dates are respectively to invoice No</p>
                </td>
                <td width="280px">
                  <table width="100%" className="__summary_box_table">
                    <tbody>
                      <tr>
                        <td width="60%">Total Unit</td>
                        <td width="40%">{footerData && Number(footerData.sum_quantity)}</td>
                      </tr>
                      <tr>
                        <td>
                          Amount
                        </td>
                        <td>
                          {currencySymbol} {footerData && Number(footerData.sum_gross_amount).toFixed(2)}
                        </td>
                      </tr>
                      <tr>
                        <td>
                          Disc %
                        </td>
                        <td>{footerData && Number(footerData.discount_percent).toFixed(2)} %</td>
                      </tr>
                      <tr>
                        <td>
                          Disc Amount
                        </td>
                        <td>{currencySymbol} {footerData && Number(footerData.discount).toFixed(2)}</td>
                      </tr>
                      <tr>
                        <td>
                          Tax Amount
                        </td>
                        <td>{currencySymbol} {footerData && Number(footerData.tax_amount).toFixed(2)}</td>
                      </tr>
                      <tr>
                        <td>
                          Return Label Fee
                        </td>
                        <td>{currencySymbol} {footerData && Number(footerData.return_label_fee).toFixed(2)}</td>
                      </tr>
                      <tr>
                        <td>
                          Net Amount
                        </td>
                        <td>{currencySymbol} {footerData && Number(footerData.net_amount).toFixed(2)}</td>
                      </tr>
                      <tr>
                        <td>
                          RA Expire Date:
                        </td>
                        <td>{footerData && moment(footerData.expiry_date).format("MM-DD-YYYY")}</td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="__reason_box">
          <table width="100%">
            <tbody>
              <tr>
                <td width="20%" valign="top">Reason:</td>
                <td>
                  {footerData && footerData.memo}
                </td>
              </tr>
              <tr>
                <td valign="top">Sale Person:</td>
                <td>
                  {footerData && footerData.salesperson_name}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </>
  )
}

export default SalesReturnReport;
